exports.baseURL = "https://admin.maalivepartyapp.com/";
exports.key = "4cb&r7dea0$nd$*$+*a(a$^x+z";
exports.projectName = "Maa Live"